import { QUEUE_VIEW_OPTIONS } from './types'
import type { QueueViewMode } from './types'

/**
 * Prefixo da chave da preferência de visão. É o ÚNICO uso de `localStorage`
 * destas telas: preferência de exibição, por usuário e por máquina. Filtro,
 * seleção e dado de fila nunca entram aqui.
 */
export const QUEUE_VIEW_STORAGE_PREFIX = 'queue-view:'

const isQueueViewMode = (value: unknown): value is QueueViewMode =>
  QUEUE_VIEW_OPTIONS.some((option) => option.value === value)

/**
 * Última visão escolhida na tela `screenKey`. Aba anônima, cookies bloqueados e
 * `localStorage` cheio lançam — e a tela abre no fallback em vez de quebrar.
 */
export function readQueueViewPreference(
  screenKey: string,
  fallback: QueueViewMode = 'list'
): QueueViewMode {
  try {
    const stored = localStorage.getItem(`${QUEUE_VIEW_STORAGE_PREFIX}${screenKey}`)
    return isQueueViewMode(stored) ? stored : fallback
  } catch {
    return fallback
  }
}

export function writeQueueViewPreference(screenKey: string, mode: QueueViewMode): void {
  try {
    localStorage.setItem(`${QUEUE_VIEW_STORAGE_PREFIX}${screenKey}`, mode)
  } catch {
    // Preferência é conveniência: perder a gravação não pode derrubar a tela.
  }
}
